import { getProducts } from "../../../Admin/State/Product/Action";
import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_PRODUCT_FAILURE,
  CREATE_PRODUCT_REQUEST,
  GET_ALL_PRODUCT_SUCCESS,
  GET_ALL_PRODUCT_REQUEST,
  GET_ALL_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllProduct = () => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.get(`vendor/products`);
    dispatch({ type: GET_ALL_PRODUCT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_PRODUCT_FAILURE, payload: error.message });
  }
};

// create full product with color, images and variants
export const createFullProduct = (formData, handleClose) => async (dispatch) => {
  dispatch({ type: CREATE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.post(
      "vendor/product/full",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (data.status === "SUCCESS") {
      dispatch(getProducts());
      dispatch(getAllProduct());
      toast.success(data.response);
      handleClose();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_PRODUCT_FAILURE, payload: error.message });
  }
};

export const updateFullProduct = (productId, formData, handleClose) => async (dispatch) => {
  dispatch({ type: UPDATE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.post(
      `vendor/product/full/${productId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (data.status === "SUCCESS") {
      dispatch(getProducts());
      dispatch(getAllProduct());
      toast.success("Product Updated Successfully");
      handleClose();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_PRODUCT_FAILURE, payload: error.message });
  }
};

export const createProduct = (productData, handleCancle) => async (dispatch) => {
  dispatch({ type: CREATE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.post(`vendor/product`, productData);
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      toast.success(data.response);
      handleCancle()
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_PRODUCT_FAILURE, payload: error.message });
  }
};

export const updateProduct = (productId, productData, handleCancle) => async (dispatch) => {
  dispatch({ type: UPDATE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `vendor/product/${productId}`,
      productData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllProduct());
      toast.success("Product Updated Successfully");
      handleCancle();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_PRODUCT_FAILURE, payload: error.message });
  }
};

export const deleteProduct = (productId, setOpenDialog) => async (dispatch) => {
  dispatch({ type: DELETE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.delete(`vendor/product/${productId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_PRODUCT_SUCCESS, payload: productId })
      dispatch(getAllProduct());
      toast.success(data.response);
      setOpenDialog(false)
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_PRODUCT_FAILURE, payload: error.message });
  }
};
